<template>
<div>

    <SquareLoader :loading="!loaded" color="#5FB0E2" size="200px"></SquareLoader>

    <div class="flex-fill overflow-auto p-0" v-if="message && loaded">
        <div class="">
            <div class="navbar navbar-light bg-light navbar-expand-lg py-lg-2 border-bottom">
                <router-link :to="{ name: 'messages.listing', params: {id: backFolder} }" tag="button" class="btn btn-outline-otu border mr-3"><font-awesome-icon class="mr-1" :icon="['fas', 'angle-left']" />{{ $t('back_button') }}</router-link>
                <div class="btn-group">
                    <router-link v-if="message.id" tag="button" class="btn btn-outline-otu border" :to="{ name: 'messages.reply', params: {folder_id: message.folder_id, id: message.id} }">
                        <font-awesome-icon class="mr-1" :icon="['fas', 'reply']" />
                        <span class="d-none d-lg-inline-block ml-2">{{ $t('messages.reply_button') }}</span>
                    </router-link>
                    <button class="btn btn-outline-otu border" v-b-modal.modalDeleteMsgs>
                        <font-awesome-icon class="mr-1" :icon="['far', 'trash-alt']" />
                        <span class="d-none d-lg-inline-block ml-2">{{ $t('delete_button') }}</span></button>
                </div>
            </div>
        </div>

        <div class="card-body border-bottom">
            <div class="flex-column flex-md-row">
                <h4 class="mb-0 font-weight-semibold" v-if="message.sender">{{ message.sender.first_name }} {{ message.sender.last_name }}</h4>
                <h5 class="mb-1 font-weight-semibold">{{ message.subject }}</h5>
                <h6 class="letter-icon-title mb-0">
                    {{ $t('messages.to')}} <span v-for="(to, key, index) in message.to" :key="key" class="text-secondary">
                        {{ to.first_name }} {{ to.last_name }}<span v-if="(index+1) != Object.keys(message.to).length">, </span>
                    </span>
                </h6>
            </div>
        </div>

        <div class="card-body p-3" v-html="body"></div>

        <!-- Modal -->
		<b-modal id="modalDeleteMsgs" :title="$t('messages.delete_confirm_title')" size="md" :ok-title="$t('delete_button')" :cancel-title="$t('cancel_button')" centered @ok="removeMessage">
			{{ $t('messages.delete_confirm_msg') }}
		</b-modal>

    </div>

</div>
</template>

<script>
import { mapActions, mapGetters } from 'vuex'

// Common OTU Components
import { EventBus, mapNotificationEventActions } from '@/lib/events.js';
import { mapCommonFilters } from '@/lib/filters.js';
import { errHandler } from '@/lib/handlers'

export default {
	name: 'MessagesRead',
    data () {
		return {
			loaded: false,
		}
	},
    components: {
		SquareLoader: () => import ('vue-spinner/src/SquareLoader'),
	},
    created () {
        this.fetchFolders().then((e) => {
            this.fetchMessage({folderId: this.$route.params.folder_id, messageId: this.$route.params.id}).then((e) => this.loaded = true );
        }).catch( (err) => console.error(err) );
    },
	filters: {
		...mapCommonFilters
	},
    computed: {
        ...mapGetters(['typeFolders']),
        message () {
			return this.$store.state.messages.message;
		},
        backFolder () {
			return (this.message.deleted_at != null && this.typeFolders(10)) ? this.typeFolders(10)[0].id : this.message.folder_id;
		},
        body () {
			// Check for HTML
			return (this.message.body.includes('<p>')) ? this.message.body : this.nl2br(this.message.body);
		}
    },
    watch: {
        $route ({params, query}) {
            this.fetchMessage({folderId: this.$route.params.folder_id, messageId: this.$route.params.id})
            .then((e) => {
                this.fetchFolders(this.currentUserId).catch( (err) => console.error (err) );
            })
        }
    },
    methods: {
        ...mapActions(['fetchMessage', 'fetchFolders', 'delMessage']),
        ...mapNotificationEventActions,
        removeMessage: function (event) {
            this.delMessage({ folderId: this.$route.params.folder_id, messageId: this.$route.params.id }).then((e) => {
                this.emitSuccess({msg: 'Message Deleted.'});
                this.fetchFolders().then((e)=>{
                    this.$router.push({ name: 'messages.listing', params: { id: this.$route.params.folder_id } });
                }).catch( (err) => console.log(err));
            }).catch( (err) => errHandler(err));
        },
        nl2br (str, replaceMode=true) {
			//var breakTag = (isXhtml) ? '<br />' : '<br>';
			var replaceStr = (replaceMode) ? '$1'+ '<br />' : '$1'+ '<br />' +'$2';
			return (str + '').replace(/([^>\r\n]?)(\r\n|\n\r|\r|\n)/g, replaceStr);
		}
    }
}
</script>
